import { Component } from 'preact'
import classNames from 'classnames'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@insided/deprecated-preact-components/modal'
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'
import ButtonControl from '@insided/deprecated-preact-components/button-control'

export interface SaveSegmentModalProps {
  onClose: () => void
  onSave: (title: string, description: string) => void
  showModal: boolean
  showGenericError: boolean
  isSubmitting: boolean
}

interface State {
  title: string
  isTitleDirty: boolean
  description: string
}

class SaveSegmentModal extends Component<SaveSegmentModalProps, State> {
  constructor(props: SaveSegmentModalProps) {
    super(props)

    this.state = {
      title: '',
      isTitleDirty: false,
      description: ''
    }
  }

  onTitleChanged = (e: ChangeEvent) => this.setState({
    title: this.getValueFromChangeEvent(e),
    isTitleDirty: true
  })

  onDescriptionChanged = (e: ChangeEvent) => this.setState({ description: this.getValueFromChangeEvent(e) })

  getValueFromChangeEvent = (e: ChangeEvent) => e.target.value

  render() {
    const {
      onClose,
      onSave,
      showModal,
      isSubmitting,
      showGenericError
    } = this.props

    const { title, isTitleDirty, description } = this.state

    const titleError = (isTitleDirty && !title) ? 'Title cannot be empty' : ''

    return (
      <Modal isOpen={showModal} size='medium'>
        <ModalHeader title='Save as segment' onClose={onClose} />
        <ModalBody>
          <InputGroup
            error={titleError}
            title='Title'
            formGroupClasses={classNames('custom-view-name-input')}
            onKeyUp={this.onTitleChanged}
            placeholder='Segment title'
            id='segment-title'
            value={title}
            newStyle
          />
          <InputGroup
            title='Description'
            formGroupClasses={classNames('custom-view-name-input')}
            onKeyUp={this.onDescriptionChanged}
            placeholder='Add your description here.'
            id='segment-description'
            newStyle
          />
          {showGenericError && (
            <div className='form-group'>
              <div className='validation-error error-message'>
                <span className='error-message-text'>There was an error, please try again later</span>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <ButtonControl
            title='Save segment'
            variant='success'
            onClick={() => onSave(title, description)}
            newStyle size='medium'
            disabled={!title || isSubmitting}
          />
          <ButtonControl title='Cancel' onClick={onClose} newStyle size='medium' />
        </ModalFooter>
      </Modal>
    )
  }
}

export default SaveSegmentModal
